export default "__VITE_ASSET__BukP3cag__"